import React from 'react';

const Services = () => (
  <section id="services" className="section-light">
    <div className="capabilities-grid">
      <div className="cap-card">
        <h4>01</h4>
        <h3>Litigation</h3>
        <p>Strategic advocacy for complex commercial disputes.</p>
      </div>
      <div className="cap-card">
        <h4>02</h4>
        <h3>Corporate</h3>
        <p>Structural oversight and entity protection.</p>
      </div>
      <div className="cap-card">
        <h4>03</h4>
        <h3>Private</h3>
        <p>Bespoke management of significant global estates.</p>
      </div>
    </div>
  </section>
);

export default Services;